export default {
  sizes: {
    sm: {
      container: {
        borderRadius: 'sm',
      },
    },
  },
  variants: {
    video: {
      container: {
        bg: 'WPPSecondaryYellow.100',
        color: 'black',
      },
    },
    display: {
      container: {
        bg: 'WPPSecondaryTeal.100',
        color: 'black',
      },
    },
  },
};
